<template>
  
    
    <el-table :data="tableData" empty-text="無資料" stripe :default-expand-all="true">

      <el-table-column label="項次" width="50">
        <template slot-scope="scope">{{scope.$index+1}}</template>
      </el-table-column>

      <el-table-column label="產品" prop="product"></el-table-column>
      
      <el-table-column label="" type="expand" >
        <template slot-scope="scope">
          <p class="mt-10 ml-10">效果: {{scope.row.result}}</p>
          <p class="mt-10 ml-10">{{scope.row.resultNotes}}</p>
          <p class="mt-10 ml-10">{{scope.row.deliveryAddress}}</p>
          <p class="mt-10 ml-10">數量: {{scope.row.qty}}</p>
          <p class="mt-10 ml-10">進度: {{scope.row.progress}}</p>
          <p class="mt-10 ml-10">花費時長:  {{scope.row.timeHour}} 時 {{scope.row.timeMinute}}分鐘</p>
          

          <TaskAttachment :fileListDisplay="scope.row.fileListDisplay" 
                          :dw="dw" 
                          :canEdit="canEdit" 
                          :loadHistoryData="loadHistoryData"></TaskAttachment>

        </template>
      </el-table-column>

      <el-table-column label="操作" width="120" v-if="canEdit">
          <template slot-scope="scope">
          
            <el-button type="primary" circle @click="handleTaskEdit(scope.row)"><i class="el-icon-edit"></i></el-button>

            <el-popconfirm
                class="ml-10 popconfirm-bg"
                title="確定刪除此筆資料嗎?"
                confirm-button-text="確定"
                cancel-button-text="取消刪除"
                icon="el-iconf-info"
                icon-color="red"
                @confirm="handleTaskRecordDelete(scope.row.id)"
            >
              <el-button type="danger" slot="reference" circle><i class="el-icon-delete"></i></el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
    </el-table>


</template>

<script>

import TaskAttachment from '@/components/task/attachment'


export default {
  name: "PaintingTask",
  components: {
    TaskAttachment
  },
  props: ['canEdit', 'dw'],
  data() {
    return {
      
      tableData:[],

      form: {
        mytodoId:''
      }

    }
  },
  methods: {

    loadHistoryData() {
      this.request.get("/todo/emp/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '日誌紀錄撈取失敗')
        }
      })
    },

    handleTaskRecordDelete(id) {
      this.request.delete("/todo/emp/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },

    handleTaskEdit(rowData) {
      // this.$parent.handleEdit(rowData)
      this.$emit('childClickEdit', rowData)
    },

    handleDelete() {

    }
    
  },
  mounted() {

    this.form.mytodoId = this.$route.params.mytodoId
    
    this.loadHistoryData();

  }
}
</script>

<style scoped>
.el-main {
  padding: 0;
  margin-bottom: 20px;
}
.el-card__body {
  padding: 0 12px;
}

</style>
